export default __webpack_public_path__ + "static/media/calconvert_m1.7bb5eb03.png";